import "./css/HeatmapPage.css";

interface HeatmapYearlyProps {
    year: number;
    registros: { fecha: string }[];
}

const diasSemana = ["L", "M", "X", "J", "V", "S", "D"];
const nombresMeses = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];

const HeatmapYearly: React.FC<HeatmapYearlyProps> = ({ year, registros }) => {

    const conteo: Record<string, number> = {};
    registros.forEach(r => {
        conteo[r.fecha] = (conteo[r.fecha] || 0) + 1;
    });

    const semanas = generarSemanasDelAno(year);
    const semanasPorMes = agruparSemanasPorMes(semanas);

    function generarSemanasDelAno(year: number) {
        const semanas: Date[][] = [];

        const fecha = new Date(year, 0, 1);

        // Ajustar al lunes anterior
        while (fecha.getDay() !== 1) {
            fecha.setDate(fecha.getDate() - 1);
        }

        const fin = new Date(year, 11, 31);

        let semana: Date[] = [];

        while (fecha <= fin) {
            semana.push(new Date(fecha));

            if (semana.length === 7) {
                semanas.push(semana);
                semana = [];
            }

            fecha.setDate(fecha.getDate() + 1);
        }

        return semanas;
    }

    function agruparSemanasPorMes(semanas: Date[][]) {
        const meses: Record<number, Date[][]> = {};

        semanas.forEach(semana => {
            const jueves = semana[3]; // jueves
            const mes = jueves.getMonth();

            if (!meses[mes]) {
                meses[mes] = [];
            }

            meses[mes].push(semana);
        });

        return meses;
    }

    return (
        <div className="heatmap-yearly-desktop">
            <div className="weekday-column">
                {diasSemana.map(d => (
                    <div key={d} className="weekday">{d}</div>
                ))}
            </div>

            <div className="heatmap-yearly-vertical">
                {/* Header días semana */}
                <div className="weekday-header">
                    <div className="month-spacer" />
                    {diasSemana.map(d => (
                        <div key={d} className="weekday">
                            {d}
                        </div>
                    ))}
                </div>

                {/* Meses */}
                {Object.entries(semanasPorMes).map(([mes, semanas]) => (
                    <div key={mes} className="month-block">

                        {/* Nombre del mes */}
                        <div className="month-label">
                            {nombresMeses[Number(mes)]}
                        </div>

                        {/* Semanas del mes */}
                        <div className="month-weeks">
                            {semanas.map((semana, i) => (
                                <div key={i} className="week-row">
                                    {semana.map(dia => {
                                        const key = dia.toLocaleDateString("sv-SE");
                                        const valor = conteo[key] || 0;

                                        return (
                                            <div
                                                key={key}
                                                className={`day lvl-${Math.min(valor, 4)}`}
                                                title={`${key} · ${valor}`}
                                            />
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HeatmapYearly;
